import React, { Component } from 'react';

import ContentPage from 'components/content-page';
import Meta from 'components/meta';
import Wrapper from 'components/wrapper';
import styles from './styles.module.css';

export default class Confidentiality extends Component {
  render() {
    return (
      <ContentPage>
        <Meta title="contact" description="" />
        <Wrapper>
          <div className={styles.contact}>
            <h1>{"J'aime les messages"}</h1>
            <p className={styles.email}>
              dis salut et écris ton mail:<br />
              <a
                href="mailto:yelkamel@gmail.com?subject=Salut%20Youcef!"
                className={styles.link}
              >
                yelkamel@gmail.com
              </a>
            </p>
          </div>
        </Wrapper>
      </ContentPage>
    );
  }
}



// WEBPACK FOOTER //
// ./contact/index.jsx